import { render, staticRenderFns } from "./TlsMarkComponent.vue?vue&type=template&id=b8596e6e&scoped=true&"
import script from "./TlsMarkComponent.vue?vue&type=script&lang=js&"
export * from "./TlsMarkComponent.vue?vue&type=script&lang=js&"
import style0 from "./TlsMarkComponent.vue?vue&type=style&index=0&id=b8596e6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8596e6e",
  null
  
)

export default component.exports